import React, { useState, useEffect, useRef } from "react";
import "@assets/css/email-notification-modal.css";
import { createPortal } from "react-dom";

// Icons for different notification types
const Icons = {
  delete: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#FFE9E9" />
      <path
        d="M24 30C24.5523 30 25 29.5523 25 29V19C25 18.4477 24.5523 18 24 18C23.4477 18 23 18.4477 23 19V29C23 29.5523 23.4477 30 24 30Z"
        fill="#FF5252"
      />
      <path
        d="M24 36C29.5228 36 34 31.5228 34 26C34 20.4772 29.5228 16 24 16C18.4772 16 14 20.4772 14 26C14 31.5228 18.4772 36 24 36ZM24 34C28.4183 34 32 30.4183 32 26C32 21.5817 28.4183 18 24 18C19.5817 18 16 21.5817 16 26C16 30.4183 19.5817 34 24 34Z"
        fill="#FF5252"
      />
    </svg>
  ),
  success: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#EAFFEF" />
      <path
        d="M24 36C29.5228 36 34 31.5228 34 26C34 20.4772 29.5228 16 24 16C18.4772 16 14 20.4772 14 26C14 31.5228 18.4772 36 24 36ZM24 34C28.4183 34 32 30.4183 32 26C32 21.5817 28.4183 18 24 18C19.5817 18 16 21.5817 16 26C16 30.4183 19.5817 34 24 34Z"
        fill="#4CAF50"
      />
      <path
        d="M22 29.5L18.5 26L17 27.5L22 32.5L31 23.5L29.5 22L22 29.5Z"
        fill="#4CAF50"
      />
    </svg>
  ),
  error: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#FFE9E9" />
      <path
        d="M24 36C29.5228 36 34 31.5228 34 26C34 20.4772 29.5228 16 24 16C18.4772 16 14 20.4772 14 26C14 31.5228 18.4772 36 24 36ZM24 34C28.4183 34 32 30.4183 32 26C32 21.5817 28.4183 18 24 18C19.5817 18 16 21.5817 16 26C16 30.4183 19.5817 34 24 34Z"
        fill="#FF5252"
      />
      <path
        d="M29.6569 20.3431L27.5355 18.2218L24 21.7574L20.4645 18.2218L18.3431 20.3431L21.8787 23.8787L18.3431 27.4142L20.4645 29.5355L24 26L27.5355 29.5355L29.6569 27.4142L26.1213 23.8787L29.6569 20.3431Z"
        fill="#FF5252"
      />
    </svg>
  ),
  warning: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#FFF9E6" />
      <path
        d="M24 30C24.5523 30 25 29.5523 25 29V19C25 18.4477 24.5523 18 24 18C23.4477 18 23 18.4477 23 19V29C23 29.5523 23.4477 30 24 30Z"
        fill="#FFB100"
      />
      <path
        d="M24 34C25.1046 34 26 33.1046 26 32C26 30.8954 25.1046 30 24 30C22.8954 30 22 30.8954 22 32C22 33.1046 22.8954 34 24 34Z"
        fill="#FFB100"
      />
      <path
        d="M14.9231 32.9177C13.6317 34.93 15.0894 37.5 17.5002 37.5H30.5002C32.9113 37.5 34.3688 34.9297 33.0771 32.9175L26.577 22.9186C25.2852 20.9063 22.4339 20.9064 21.1421 22.9186L14.9231 32.9177ZM17.7924 33.8944L23.1421 24.9189C23.3921 24.5313 23.9921 24.5313 24.2421 24.9189L29.8079 33.8944C30.0581 34.2821 29.808 34.7778 29.3581 34.7778H18.2422C17.7921 34.7778 17.542 34.2821 17.7924 33.8944Z"
        fill="#FFB100"
      />
    </svg>
  ),
  info: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#E9F5FF" />
      <path
        d="M24 36C29.5228 36 34 31.5228 34 26C34 20.4772 29.5228 16 24 16C18.4772 16 14 20.4772 14 26C14 31.5228 18.4772 36 24 36ZM24 34C28.4183 34 32 30.4183 32 26C32 21.5817 28.4183 18 24 18C19.5817 18 16 21.5817 16 26C16 30.4183 19.5817 34 24 34Z"
        fill="#0088FF"
      />
      <path
        d="M23 22C23 21.4477 23.4477 21 24 21C24.5523 21 25 21.4477 25 22V30C25 30.5523 24.5523 31 24 31C23.4477 31 23 30.5523 23 30V22Z"
        fill="#0088FF"
      />
      <path
        d="M24 20C24.5523 20 25 19.5523 25 19C25 18.4477 24.5523 18 24 18C23.4477 18 23 18.4477 23 19C23 19.5523 23.4477 20 24 20Z"
        fill="#0088FF"
      />
    </svg>
  ),
};

// Utility function to generate unique IDs
const generateId = () => `modal-${Math.random().toString(36).substring(2, 9)}`;

/**
 * Email Notification Modal Component
 *
 * @param {Object} props Component props
 * @param {boolean} props.isOpen Whether the modal is open
 * @param {function} props.onClose Function to close the modal
 * @param {string} props.type Type of notification (delete, success, error, warning, info)
 * @param {string} props.title Modal title
 * @param {string} props.message Modal message
 * @param {string} props.confirmText Text for confirm button
 * @param {string} props.cancelText Text for cancel button
 * @param {function} props.onConfirm Function to call when confirm button is clicked
 * @param {number} props.autoCloseTime Time in ms after which modal auto closes (0 to disable)
 * @param {string} props.position Position of the modal (center, top, bottom)
 * @param {boolean} props.showCloseButton Whether to show close button
 * @param {Object} props.customIcon Custom icon component
 */
const EmailNotificationModal = ({
  isOpen = false,
  onClose = () => {},
  type = "info",
  title = "",
  message = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm = null,
  autoCloseTime = 0,
  position = "center",
  showCloseButton = true,
  customIcon = null,
}) => {
  // State for managing modal visibility and animation
  const [isVisible, setIsVisible] = useState(false);
  const [modalId] = useState(generateId());
  const timeoutRef = useRef(null);
  const progressRef = useRef(null);

  // Classes for different notification types
  const typeClasses = {
    delete: "email-modal-delete",
    success: "email-modal-success",
    error: "email-modal-error",
    warning: "email-modal-warning",
    info: "email-modal-info",
  };

  // Position classes
  const positionClasses = {
    center: "email-modal-center",
    top: "email-modal-top",
    bottom: "email-modal-bottom",
  };

  // Effect for handling modal open/close and animations
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.style.overflow = "hidden"; // Prevent background scrolling

      // Set up auto-close timer if specified
      if (autoCloseTime > 0) {
        if (progressRef.current) {
          progressRef.current.style.transition = `width ${autoCloseTime}ms linear`;
          progressRef.current.style.width = "0%";
        }

        timeoutRef.current = setTimeout(() => {
          handleClose();
        }, autoCloseTime);
      }
    } else {
      handleClose();
    }

    // Cleanup
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      document.body.style.overflow = ""; // Restore scrolling when component unmounts
    };
  }, [isOpen, autoCloseTime]);

  // Handle closing the modal
  const handleClose = () => {
    setIsVisible(false);

    // Wait for animation to finish before calling onClose
    setTimeout(() => {
      onClose();
    }, 300);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  // Handle confirm button click
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    handleClose();
  };

  // If modal is not open, don't render anything
  if (!isOpen && !isVisible) {
    return null;
  }

  // Get appropriate icon based on type
  const icon = customIcon || Icons[type] || Icons.info;

  // Render modal content
  const modalContent = (
    <div
      className={`email-modal-overlay ${isVisible ? "visible" : ""}`}
      onClick={showCloseButton ? handleClose : null}
      data-testid="email-modal-overlay"
    >
      <div
        className={`email-modal ${typeClasses[type] || ""} ${
          positionClasses[position] || "email-modal-center"
        } ${isVisible ? "visible" : ""}`}
        onClick={(e) => e.stopPropagation()}
        data-testid="email-modal"
        id={modalId}
      >
        {/* Progress bar for auto-close */}
        {autoCloseTime > 0 && (
          <div className="email-modal-progress-container">
            <div className="email-modal-progress" ref={progressRef}></div>
          </div>
        )}

        {/* Close button */}
        {showCloseButton && (
          <button
            className="email-modal-close"
            onClick={handleClose}
            aria-label="Close"
            data-testid="email-modal-close"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 1L1 13M1 1L13 13"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}

        {/* Modal content */}
        <div className="email-modal-content">
          <div className="email-modal-icon">{icon}</div>

          <div className="email-modal-text">
            {title && <h2 className="email-modal-title">{title}</h2>}
            {message && <p className="email-modal-message">{message}</p>}
          </div>

          {/* Buttons */}
          <div className="email-modal-actions">
            {onConfirm && (
              <>
                <button
                  className="email-modal-button email-modal-cancel"
                  onClick={handleClose}
                  data-testid="email-modal-cancel"
                >
                  {cancelText}
                </button>
                <button
                  className={`email-modal-button email-modal-confirm email-modal-${type}-button`}
                  onClick={handleConfirm}
                  data-testid="email-modal-confirm"
                  autoFocus
                >
                  {confirmText}
                </button>
              </>
            )}

            {!onConfirm && (
              <button
                className={`email-modal-button email-modal-confirm email-modal-${type}-button`}
                onClick={handleClose}
                data-testid="email-modal-ok"
                autoFocus
              >
                OK
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  // Use React Portal to render modal outside of normal DOM hierarchy
  return createPortal(modalContent, document.body);
};

export default EmailNotificationModal;
